import { useAuthStore } from '@/stores/auth.store';
import { useLogin } from './useAuth';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { LoginPayload, loginSchema } from '@/schemas/login.schema';

export const useLoginData = () => {
    const { isLoggingIn } = useAuthStore();
    const loginMutation = useLogin();




    const {
        register,
        handleSubmit,
        formState: { errors, isValid, isSubmitting },
    } = useForm<LoginPayload>({
        resolver: zodResolver(loginSchema),
    });


    const onSubmit = (values: LoginPayload) => {
        loginMutation.mutate(values);
    };


    return {
        register,
        handleSubmit,
        onSubmit,
        errors,
        isLoggingIn,
        isValid,
        isSubmitting,
    };
};
